import { render, staticRenderFns } from "./InformationClassification.vue?vue&type=template&id=294a02be&scoped=true"
import script from "./InformationClassification.vue?vue&type=script&lang=js"
export * from "./InformationClassification.vue?vue&type=script&lang=js"
import style0 from "./InformationClassification.vue?vue&type=style&index=0&id=294a02be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294a02be",
  null
  
)

export default component.exports